const baseStyle = {
  borderRadius: 'md',
  py: 2,
  px: 2,
};

const defaultProps = {
  variant: 'ghost',
};

export default {
  baseStyle,
  defaultProps,
};
